module.exports = __webpack_public_path__ + "img/mhtit2.1bf7c475.png";